import { CheckCircle2, X, Loader2 } from "lucide-react";

export default function SyncActivityCard({ counts, phase, onDismiss }) {
  if (phase === "idle" || phase === "dismissed") return null;

  const isStable = phase === "stable";

  return (
    <div className="fixed bottom-6 right-6 z-50 w-72 bg-white border border-slate-200 rounded-2xl shadow-xl overflow-hidden animate-in slide-in-from-bottom-4 duration-300">
      {/* Header */}
      <div className={`flex items-center justify-between px-4 py-3 ${isStable ? "bg-emerald-50 border-b border-emerald-100" : "bg-blue-600"}`}>
        <div className="flex items-center gap-2">
          {isStable
            ? <CheckCircle2 size={16} className="text-emerald-600" />
            : <Loader2 size={16} className="text-white animate-spin" />}
          <span className={`text-[13px] font-bold ${isStable ? "text-emerald-800" : "text-white"}`}>
            {isStable ? "All caught up!" : "Syncing WhatsApp…"}
          </span>
        </div>
        <button
          onClick={onDismiss}
          className={`w-6 h-6 flex items-center justify-center rounded-md transition ${isStable ? "hover:bg-emerald-100 text-emerald-600" : "hover:bg-blue-500 text-white"}`}
        >
          <X size={13} />
        </button>
      </div>

      {/* Counts */}
      <div className="px-4 py-3 space-y-2">
        <CountRow
          icon="chat"
          label="Messages received"
          count={counts.messages}
          color="text-blue-600"
        />
        <CountRow
          icon="task_alt"
          label="Tasks created"
          count={counts.tasks}
          color="text-emerald-600"
        />
        {counts.review > 0 && (
          <CountRow
            icon="fact_check"
            label="Need your review"
            count={counts.review}
            color="text-amber-600"
          />
        )}
        {isStable && (
          <p className="text-[11px] text-slate-400 pt-1">Auto-closing in a moment…</p>
        )}
      </div>
    </div>
  );
}

function CountRow({ icon, label, count, color }) {
  return (
    <div className="flex items-center gap-2.5">
      <span
        className={`material-symbols-outlined text-[17px] ${color}`}
        style={{ fontVariationSettings: "'FILL' 1" }}
      >
        {icon}
      </span>
      <span className="text-[12.5px] text-slate-600 flex-1">{label}</span>
      <span className={`text-[14px] font-bold tabular-nums ${color}`}>{count}</span>
    </div>
  );
}
